

import React from "react";

import Grid from "@mui/material/Grid";
import {
  AuthBg,
  Left,
  Right,
  Logo,
  Icon1,
  Icon2,
  AuthContent,
  AuthContainer,
} from "./styles";
import useResponsive from "src/components/hooks/useResponsive";
function AuthLayout({ children, ...props }) {
  const { isDesktop } = useResponsive();

  return (
    <AuthContainer maxWidth="xl" >

      <Grid container>
        <Left item xs={12} sm={12} md={6}>
          <Logo />
          <AuthContent>
            <div>{children}</div>
          </AuthContent>
        </Left>
        {isDesktop && (
          <Right item xs={6}>
            <Icon2 />
          </Right>
        )}

      </Grid>
    </AuthContainer>
  );
}

export default AuthLayout;
